<!-- <app-header-one ></app-header-one> -->
<app-header-latest></app-header-latest>

<section class="terms-popup">
    <div class="popup-container">

        <div class="popup-card">
            <!-- <h2 class="title">{{tncData.title}}</h2> -->
            <!-- <div [innerHTML]="tncData.description"></div> -->
        </div>

        <div class="popup-card">
            <h2 class="title" style="cursor: pointer;">Refund Policy</h2>

            <h2>1. Introduction</h2>
            <p>
                This Refund Policy <strong>("Policy")</strong> explains the circumstances under which refunds may be granted
                for subscriptions, licenses, implementation services, professional services, training
                services, and other paid offerings of the NeoHRMZ <strong>("Platform", "Company", "we", "our",</strong>
                or <strong>"us").</strong>
            </p>

            <p>
                By purchasing or subscribing to our HRMS services, you agree to this Refund Policy
                together with our Terms &amp; Conditions and Subscription Agreement.
            </p>

            <h2>2. Nature of Services</h2>
            <p>
                The HRMS Platform is a Software-as-a-Service (SaaS) solution that provides cloud-based
                Human Resource Management services including, but not limited to Employee Information
                Management, Payroll Management, Attendance &amp; Leave Management, Recruitment (ATS),
                Performance Management, Learning Management, Employee Self-Service (ESS), Workforce
                Analytics, AI-powered HR Features, Mobile Applications, Integrations, and Professional
                Services.
            </p>

            <h2>3. Free Trial / Demo</h2>
            <p>
                Where a free trial or product demonstration is offered Customers are encouraged to
                evaluate the Platform before purchasing. No payment is required during the trial period
                unless otherwise stated. Once a paid subscription begins, the trial period ends
                automatically.
            </p>

            <h2>4. Subscription Fees</h2>
            <p>
                Subscription fees may include Monthly Subscription, Quarterly Subscription,
                Half-Yearly Subscription, Annual Subscription, Enterprise Licensing, Add-on Modules,
                AI Services, Additional Storage, and Premium Support.
                All applicable taxes shall be charged separately where required.
            </p>

            <h2>5. Refund Eligibility</h2>
            <p>Refunds may be considered only under the following circumstances:</p>

            <ul>
                <li>•  Duplicate payment due to technical error.</li>
                <li>•  Incorrect amount charged because of a billing error by the Company.</li>
                <li>•  Payment processed after a valid cancellation request because of a system error.</li>
                <li>
                    •  Subscription purchased but not activated due to a Company-side technical issue
                    that cannot be resolved within a reasonable period.
                </li>
                <li>•  Refunds required under applicable law.</li>
                <li>•  Each request is reviewed individually.</li>
            </ul>

            <h2>6. Non-Refundable Items</h2>
            <p>
                Unless otherwise required by law or expressly agreed in writing, the following are
                generally <strong>non-refundable:</strong>
            </p>

            <ul>
                <li>•  Monthly subscription fees after activation.</li>
                <li>•  Annual subscription fees after activation.</li>
                <li>•  Setup or onboarding fees.</li>
                <li>•  Implementation services.</li>
                <li>•  Configuration and customization services.</li>
                <li>•  Data migration services.</li>
                <li>•  API integration services.</li>
                <li>•  Training services.</li>
                <li>•  Consulting services.</li>
                <li>•  Premium support plans.</li>
                <li>•  White-label branding fees.</li>
                <li>•  Third-party licensing charges.</li>
                <li>•  Taxes and government levies already remitted.</li>
                <li>
                    •  Charges for additional users, storage, or purchased add-on modules that have been
                    provisioned.
                </li>
            </ul>

            <h2>7. Monthly Subscription</h2>
            <p>
                Customers may cancel a monthly subscription at any time. Access continues until the end
                of the paid billing cycle. No prorated refund is provided for unused days of the current
                billing period unless required by applicable law or expressly approved by the Company.
            </p>

            <h2>8. Annual Subscription</h2>
            <p>
                Customers may cancel an annual subscription before renewal. Access remains available
                until the end of the prepaid subscription term. Partial refunds for unused months are
                not available unless otherwise stated in a separate agreement or required by law.
            </p>

            <h2>9. Enterprise Agreements</h2>
            <p>
                Enterprise customers operating under Master Service Agreement (MSA), Enterprise
                Subscription Agreement, Government Contracts or Corporate Agreements shall be governed
                by the refund provisions contained in those agreements, which take precedence over this
                Policy.
            </p>

            <h2>10. Implementation Services</h2>
            <p>
                Fees paid for HRMS implementation, System configuration, Business process mapping,
                Workflow setup, Payroll configuration, or Employee data migration are non-refundable
                once work has commenced.
            </p>

            <h2>11. Professional Services</h2>
            <p>
                Charges for HR consulting, Payroll consulting, Compliance consulting, Custom
                development, API development, and Integration services are non-refundable after service
                delivery has begun.
            </p>

            <h2>12. Data Migration</h2>
            <p>
                Fees relating to Employee records migration, Payroll migration, Attendance migration,
                Leave migration, and Historical data imports are non-refundable once migration
                activities have started.
            </p>

            <h2>13. Training Services</h2>
            <p>
                Fees for Online training, Classroom training, Administrator certification or Corporate
                workshops are non-refundable once the training session has commenced.
            </p>

            <h2>14. Add-on Modules</h2>
            <p>
                Purchased add-ons, including Recruitment (ATS), Learning Management, Performance
                Management, AI Assistant, Employee Engagement, Advanced Analytics or Biometric
                Integrations are non-refundable once enabled.
            </p>

            <h2>15. Technical Issues</h2>
            <p>If a technical issue prevents access to the Platform:</p>

            <ul>
                <li>•  Clients should contact Customer Support promptly.</li>
                <li>•  NeoHRMZ will make commercially reasonable efforts to resolve the issue.</li>
                <li>
                    •  Where the issue is solely attributable to the Company and cannot be resolved within
                    a reasonable period, the Company may, at its discretion, provide a refund, service
                    credit, or subscription extension.
                </li>
            </ul>

            <h2>16. Refund Request Process</h2>
            <p>Refund requests should include:</p>

            <ul>
                <li>•  Customer Name</li>
                <li>•  Organization Name</li>
                <li>•  Registered Email Address</li>
                <li>•  Invoice Number</li>
                <li>•  Transaction ID</li>
                <li>•  Payment Date</li>
                <li>•  Amount Paid</li>
                <li>•  Reason for Request</li>
                <li>•  Supporting Documents (if applicable)</li>
            </ul>

            <h2>17. Refund Review</h2>
            <p>
                Each request will be reviewed based on Subscription status, Service activation, Product
                usage, Billing records, Contract terms, and Applicable law. NeoHRMZ's decision will be
                communicated after review.
            </p>

            <h2>18. Refund Method</h2>
            <p>
                Approved refunds will normally be credited to the original payment method used for the
                transaction, unless otherwise required by law or agreed by the parties.
            </p>

            <h2>19. Refund Timeline</h2>
            <p>
                If approved, refunds are processed within <strong>15 business days </strong> after approval. The actual
                credit may depend on the customer's bank, card issuer, payment gateway, or financial
                institution.
            </p>

            <h2>20. Chargebacks</h2>
            <p>
                Clients are encouraged to contact Customer Support before initiating a chargeback.
                Fraudulent or abusive chargebacks may result in:
            </p>

            <ul>
                <li>•  Suspension of the account</li>
                <li>•  Termination of services</li>
                <li>•  Recovery of outstanding amounts</li>
                <li>•  Other actions permitted by law or contract</li>
            </ul>

            <h2>21. Fraud Prevention</h2>
            <p>NeoHRMZ reserves the right to deny refunds where there is evidence of:</p>

            <ul>
                <li>•  Payment fraud</li>
                <li>•  Identity theft</li>
                <li>•  Abuse of free trials</li>
                <li>•  Multiple refund requests</li>
                <li>•  Unauthorized account usage</li>
                <li>•  Violation of the Terms &amp; Conditions</li>
            </ul>

            <h2>22. Taxes</h2>
            <p>
                Applicable taxes, duties, and statutory charges may not be refundable where already
                remitted to the relevant authorities, except as required by applicable law.
            </p>

            <h2>23. Cancellation vs Refund</h2>
            <ul>
                <li>•  Cancelling a subscription prevents future renewals.</li>
                <li>
                    •  Cancellation does not automatically entitle the customer to a refund unless
                    specifically permitted under this Policy or required by applicable law.
                </li>
            </ul>

            <h2>24. Policy Changes</h2>
            <p>
                NeoHRMZ may update this Refund Policy from time to time. The revised version will become
                effective upon publication on the Platform, unless otherwise stated.
            </p>

            <h2>25. Contact Information</h2>

            <p>For refund-related queries, customers may contact:</p>

             <ul >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li><strong><i class="fa fa-envelope-o"></i>	Email:</strong> <a href="mailto:supportwhiterobe.in"> contact&#64;neohrmz.com</a></li><br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li><strong><i class="fa fa-phone"></i>	Phone:</strong> +91-984 984 8195</li><br>
    </ul>

            <p>
                Review our
                <a (click)="goTo('/terms-and-conditions')">Terms &amp; Conditions</a>
                and
                <a (click)="goTo('/privacy')">Privacy Policy</a>
                for further details.
            </p>

        </div>

    </div>
</section>

<!-- <app-footer-one></app-footer-one> -->
<!-- <app-footer-more-info></app-footer-more-info> -->
<app-peopleflow-footer></app-peopleflow-footer>